<template>
  <div>
    <v-card
      color="#FFFFFF"
      
      width="1264px"
      min-height="250"
      class="pt-6"
      style="border-bottom-left-radius: 8px !important; border-bottom-right-radius: 8px !important; border-top-left-radius: 0px !important; border-top-right-radius: 0px !important;"
    >
      <v-row class="ma-0"
      >
        <v-col md="4" cols="11">
          <v-row class="ma-0">
            <v-img
              style="cursor: pointer;"
              :src="logo_head"
              class="logo mt-1 ml-12"
              max-height="120"
              max-width="180"
              @click="goToPage('main')"
            ></v-img>
          </v-row>
          <v-row class="ma-0 ml-4">
            <v-col>
              <p class="foot-label">Телефон и факс</p>
              <p class="foot-text">
                +375 (17) 379–28–16
              </p>
            </v-col>
            <v-col>
              <p class="foot-label">Почта</p>
              <p class="foot-text">office@cys-iaas.net</p>
            </v-col>
          </v-row>
          <v-row class="ma-0 ml-4">
            <v-col>
              <p class="foot-label">Штаб-квартира</p>
              <p class="foot-text">Пр. Независимости 68, 220072, Минск, Минская область, Беларусь</p>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="1" cols="1"></v-col>
        <v-col md="6" cols="12" class="ml-4">
          <v-row class="ma-0">
            <v-col>
              <v-row>
                <b class="mb-1" style="cursor: pointer;" @click="goToPage('main')">Главная</b>
              </v-row>
              <v-row>
                <p class="mb-0 foot-line" style="cursor: pointer;" @click="goToPage('main_about')">О нас</p>
              </v-row>
              <v-row>
                <p class="mb-0 foot-line" style="cursor: pointer;" @click="goToPage('main_history')">История ассоциации</p>
              </v-row>
              <v-row>
                <p class="mb-0 foot-line" style="cursor: pointer;" @click="goToPage('main_news')">Новости</p>
              </v-row>

            </v-col>
            <v-col>
              <v-row>
                <b class="mb-1" style="cursor: pointer;" @click="goToPage('about')">СМУ МААН</b>
              </v-row>
              <v-row>
                <p class="mb-0 foot-line" style="cursor: pointer;" @click="goToPage('about_cys')">Совет молодых ученых</p>
              </v-row>
              <v-row>
                <p class="mb-0 foot-line" style="cursor: pointer;" @click="goToPage('about_tasks')">Цели и задачи</p>
              </v-row>
              <v-row>
                <p class="mb-0 foot-line" style="cursor: pointer;" @click="goToPage('about_docs')">Полезные документы</p>
              </v-row>
            </v-col>
            <v-col>
              <v-row>
                <b class="mb-1" style="cursor: pointer;" @click="goToPage('members')">Состав СМУ МААН</b>
              </v-row>
              <v-row>
                <p class="mb-0 foot-line" style="cursor: pointer;" @click="goToPage('members_chairmans')">Бюро СМУ</p>
              </v-row>
              <v-row>
                <p class="mb-0 foot-line" style="cursor: pointer;" @click="goToPage('members_persons')">Члены СМУ МААН</p>
              </v-row>
              <v-row>
                <p class="mb-0 foot-line" style="cursor: pointer;" @click="goToPage('members_groups')">Рабочие группы СМУ МААН</p>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="news_dialog"   max-width="1050px" style="overflow-x: hidden !important;">
      <v-card id="news_title">
        <v-card-actions>
          <v-spacer></v-spacer>
          <span
            @click="news_dialog = false"
          >
            <v-icon>mdi-window-close</v-icon>
          </span>
        </v-card-actions>
            
        <v-card-title
          style="font-size: 44px; line-height: 3rem;"
          class="pl-12 pr-12 pb-4"
        >
          <p>{{ GETTERS_CURRENT_NEWS.descr }}</p>
        </v-card-title>

        <!-- <v-card-text>
          {{ GETTERS_CURRENT_NEWS.text }}
        </v-card-text> -->

          <v-row class="pl-12 pr-12 ma-0">
            <v-card-text class="pa-0">
              <p v-for="t in GETTERS_CURRENT_NEWS.text" style=" font-size: 22px; text-indent: 10px;">{{ t }}</p>
            </v-card-text>
          </v-row>
        
        <v-card-text class="pa-12">
          <v-img
              style="border-radius: 16px !important;"

              rounded="xxl"

              :src="GETTERS_CURRENT_NEWS.src"
          ></v-img>
        </v-card-text>

      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import logo from '../../assets/ustoc.png';
import logo_head from '../../assets/logo-head.svg';
import {mapMutations, mapGetters } from 'vuex';

export default {
  name: 'HeaderForPage',
  components: {
  },

  data() {
    return {
      logo,
      logo_head,
      news_dialog: false,
    }
  },

  mounted() {
  },

  computed: {
    ...mapGetters(['GETTERS_CURRENT_NEWS', 'GETTERS_SHOW_NEWS']),
  },

  watch: {
    GETTERS_SHOW_NEWS(val){
      this.news_dialog = val

      if(val){
        setTimeout(() => {
          this.scroll_to_header()
          }, 250)
      }
    },
    
    news_dialog(val){
      if(!val){
        this.SET_SHOW_NEWS(false)
      }
    }
  },

  methods: {
    ...mapMutations([
      'SET_SHOW_NEWS',
    ]),

    scroll_to_header(){
      const el = document.querySelector("#news_title");
        // console.log('GETTERS_SHOW_NEWS', el)
        if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          }
    },

    async goToPage(item) {
      switch (item) {
        // case 'main':
        //   this.$router.push('/');
        //   break;
        case 'main':
          this.$router.push({ path: '/', hash: '#top' });
          break;
        case 'main_about':
          this.$router.push({ path: '/', hash: '#about' });
          break;
        case 'main_history':
          this.$router.push({ path: '/', hash: '#history' });
          break;
        case 'main_news':
          this.$router.push({ path: '/', hash: '#news' });
          break;
        case 'privacy':
          this.$router.push('/privacy');
          break;

        case 'about':
          this.$router.push({ path: '/about', hash: '#top' });
        // this.$router.push('/about');
          // this.$router.scrollBehavior();
          break;
        case 'about_tasks':
          this.$router.push({ path: '/about', hash: '#tasks' });
          // this.$router.scrollBehavior();
          break;
          case 'about_cys':
          this.$router.push({ path: '/about', hash: '#cys' });
          // this.$router.scrollBehavior();
          break;
        case 'about_docs':
          this.$router.push({ path: '/about', hash: '#docs' });
          // this.$router.scrollBehavior();
          break;
        case 'members':
          this.$router.push({ path: '/members', hash: '#top' });
        // this.$router.push('/members');
          break;
        case 'members_chairmans':
          this.$router.push({ path: '/members', hash: '#chairmans' });
          break;
        case 'members_persons':
          this.$router.push({ path: '/members', hash: '#persons' });
          break;
        case 'members_groups':
          this.$router.push({ path: '/members', hash: '#groups' });
          break;
        case 'leadership':
          this.$router.push('/leadership');
          break;
        case 'news':
          this.$router.push('/news');
          break;
        default:
          break;
      }
    },
  },
};
</script>

